import { RouteConfig } from 'vue-router';
// import MswUsageReport from './msw-usage-report.vue';
import MswUsageReport from './msw-license-report.vue';

const route: RouteConfig = {
  path: 'usage-report',
  component: MswUsageReport,
};

export function getDefaultParams() {
  return {};
}

export default route;
